import { lazy, Suspense, useContext, useEffect, useState } from 'react';
import TrainTimeTable from '../trainTrainTimeTable/TrainTimeTable';
import AmtrakFaq from '../amtrakFaq/amtrakFaq';
import AirportStations from '../airportStations/airportStationsPage';
import ViaFaq from '../viaFaq/viaFaq';
import './homeComponent.scss';
import SearchBox from './searchBox/SearchBox';
import CareersSection from './careersSection/CareersSection';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { Redirect } from 'react-router';
import DiscoverSectionContext from '../context/discoverSectionPages';
import EurailPassPage from '../eurailPassPage/EurailPassPage';
import NationalRailPage from '../nationalRailPage/NationalRailPage';
import DiscoverSection from './discoverSection/DiscoverSection';
import { Helmet } from "react-helmet-async";
import { useLocation } from 'react-router-dom';
import { homeLinks } from '../topNavigation/TopNavigation';
import { setSelectedSearchBoxTab } from '../redux/actions/homeActions';
import { setRailPassSelectedCounty } from '../redux/actions/searchActions';
import BannerSection from './bannerSection/BannerSection';
import { setPassType } from '../redux/actions/commonActions';

const HomeComponent = () => {
  const browseFrom = useAppSelector((state) => state.common.browseFrom);
  const dispatch = useAppDispatch();
  const location = useLocation();

  const PopularJourneySection = lazy(() => import('./popularJourneySection/PopularJourneySection'));

  const routeLocation = useLocation();

  const user = useAppSelector((state) => state.loggedInUser.profile);
  const [redirect, setRedirect] = useState<boolean>(false);
  const { type } = useContext(DiscoverSectionContext);

  useEffect(() => {
    if (location.pathname === '/book-eurail-pass') {
      setTimeout(() => {
        dispatch(setSelectedSearchBoxTab('Eurail Pass'));
        dispatch(setRailPassSelectedCounty(''));
        dispatch(setPassType(true));
      }, 0)
    }

    if (location.pathname === '/book-interrail-pass') {
      setTimeout(() => {
        dispatch(setSelectedSearchBoxTab('Interrail Pass'));
        dispatch(setRailPassSelectedCounty(''));
        dispatch(setPassType(false));
      }, 0)
    }
  }, [dispatch, location.pathname])

  useEffect(() => {
    if (user?.userRole === "B2BAdmin" || user?.userRole === "B2BAgent") {
      setRedirect(true)
    } else {
      setRedirect(false)
    }
  }, [])

  let pageToLoad = <DiscoverSection />

  switch (type) {
    case 'EurailPassPage':
      pageToLoad = <EurailPassPage />
      break;
    case 'NationalRailPage':
      pageToLoad = <NationalRailPage />
      break;
    case 'AmtrakFaq':
      pageToLoad = <AmtrakFaq />
      break;
    case 'AirportStations':
      pageToLoad = <AirportStations />
      break;
    case 'ViaFaq':
      pageToLoad = <ViaFaq />
      break;
    case 'TrainTimeTable':
      pageToLoad = <TrainTimeTable />
      break;
    case undefined:
      pageToLoad = <DiscoverSection />
      break;
    default:
      pageToLoad = <DiscoverSection />
  }

  return (
    redirect ? <Redirect to='/agency-dashboard' /> :
      <div className="container-fluid">
        <Helmet>
          <title>Rail Online - Buy Cheap Train Tickets in UK & Europe Online</title>
          <meta name="description" content="Rail Online is a quick & easy way to book cheap train tickets across UK & Europe. Take the scenic route with terrific deals on train tickets." />
          {homeLinks.includes(routeLocation.pathname.toLowerCase()) && <link rel="canonical" href={'https://www.rail.online'} />}
        </Helmet>
        <div className="row">
          <div className="col-sm-12 p-0">
            <div className="hero-image-container">
              <BannerSection browseFrom={browseFrom} />
              <div className="search-box max-width">
                <SearchBox />
              </div>
           
                <CareersSection />
                
             
              {/* {
                browseFrom === ApplicationProviderRouteEnum.UK ? (
                  <>
                     <MobileAppDownloadSection />
                  </>
                ) : (
                  <>
                    <CareersSection />
                  </>
                )
              } */}
            </div>
            {/* {
              browseFrom === ApplicationProviderRouteEnum.UK ? (
                <>
                  <CareersSection />
                </>
              ) : (
                <>
                  <MobileAppDownloadSection />
                </>
              )
            } */}
            {pageToLoad}
            <Suspense fallback={<p>Loading...</p>}>
              <PopularJourneySection />
            </Suspense>
          </div>
        </div>
      </div>
  );
}

export default HomeComponent;
